// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1845":"ccd28095","2803":"ccd28095","5935":"ccd28095","6456":"ccd28095","7471":"ccd28095","9029":"ccd28095","9996":"ccd28095"}[chunkId] + ".chunk.css";
};